import React, { useEffect, useState } from 'react'
import { useAppContext } from '@/context/app'
import { Roles } from '@/services/repository/users'
import './MachineBillingStartDate.css'

export const MachineBillingStartDate = ({ machineId }: { machineId?: string }) => {
  const { session, services } = useAppContext()
  const [value, setValue] = useState('')
  const [loaded, setLoaded] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const allowed = session?.user.role === Roles.HyperAdmin
  const path = '/api/hyperadmin/billing/machines/' + machineId + '/start-date'
  useEffect(() => {
    let active = true
    setLoaded(false); setError(''); setMessage('')
    if (allowed && machineId) {
      void (async () => {
        try {
          const response = await services.session.fetchWithToken(path)
          const data = await response.json()
          if (!response.ok) throw new Error(data.error || 'Nie udało się pobrać daty naliczania')
          if (active) { setValue(data.startDate || ''); setLoaded(true) }
        } catch (e) { if (active) setError(e instanceof Error ? e.message : String(e)) }
      })()
    }
    return () => { active = false }
  }, [allowed, machineId])
  if (!allowed || !machineId) return null
  const save = async () => {
    setBusy(true); setError(''); setMessage('')
    try {
      const response = await services.session.fetchWithToken(path, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ startDate: value || null }) })
      const data = await response.json()
      if (!response.ok) throw new Error(data.error || 'Nie udało się zapisać daty naliczania')
      setMessage('Zapisano datę naliczania')
    } catch (e) { setError(e instanceof Error ? e.message : String(e)) }
    finally { setBusy(false) }
  }
  return <div className='billing-machine-start'>
    <div className='billing-machine-start-row'>
      <label>Data rozpoczęcia naliczania (opcjonalna)
        <input type='date' value={value} disabled={!loaded || busy} onChange={e => { setValue(e.target.value); setMessage('') }} />
      </label>
      <button type='button' disabled={!loaded || busy} onClick={() => void save()}>Zapisz datę naliczania</button>
    </div>
    <p className='billing-machine-start-hint'>Puste pole: naliczanie od obecności maszyny w płatnych grupach. Ustawiona data pomija wcześniejsze dni w okresach kończących się po jej zapisaniu (także w rozliczeniach na żądanie za miniony okres obowiązuje data sprzed jego końca). Gotowe rozliczenia pozostają bez zmian.</p>
    {error && <p className='billing-machine-start-error' role='alert'>{error}</p>}
    {message && <p className='billing-machine-start-ok' role='status'>{message}</p>}
  </div>
}
